/**
 * Deterministic string hash (djb2 variant). Used to derive stable, side-effect-free
 * visual values from identifiers — e.g. a gradient angle from a `userId`.
 *
 * Not cryptographic. Collisions are fine; we only need determinism.
 */
export function hashString(str) {
    let hash = 5381;
    for (let i = 0; i < str.length; i += 1) {
        hash = (hash * 33) ^ str.charCodeAt(i);
    }
    // Coerce to unsigned 32-bit so downstream modulo math behaves.
    return hash >>> 0;
}
/**
 * Maps a `userId` (or any stable string) to a gradient angle in `[0, 360)` degrees.
 * The same input always returns the same angle, so a user's avatar gradient stays
 * consistent across sessions without any server-side storage.
 */
export function userIdToGradientAngle(userId) {
    return hashString(userId) % 360;
}
